import { TreeItem, TreeView, TreeViewProps } from '@mui/lab';
import FolderIcon from '@mui/icons-material/Folder';
import { DataRoomFolder } from '../models';
import React from 'react';

interface CerebroHierarchyFolderTreeProps {
	folder: DataRoomFolder;
	selectedGuid: string | undefined;
	onSelected?: (value: string) => void;
}

export const CerebroHierarchyFolderTree: React.FC<CerebroHierarchyFolderTreeProps> = ({
	folder,
	selectedGuid,
	onSelected,
}) => {
	const defaultFolderGuid: string = selectedGuid ? selectedGuid : folder.guid;

	const [expanded] = React.useState<string[]>(getNodeIds(folder));
	const [userSelection, setUserSelection] = React.useState<string>(defaultFolderGuid);

	const onChangeSelected = (id: string) => {
		setUserSelection(id);
		if (onSelected) {
			onSelected(id);
		}
	};

	return (
		<TreeView
			defaultCollapseIcon={<FolderIcon />}
			defaultExpandIcon={<FolderIcon />}
			defaultEndIcon={<FolderIcon />}
			expanded={expanded}
			selected={userSelection}
			onNodeSelect={(node: any) => {
				onChangeSelected(node.target.firstChild.parentElement.parentElement.parentElement.id.substring(14));
			}}
		>
			<CerebroHierarchyTreeItem selectedGuid={selectedGuid} folder={folder} />
		</TreeView>
	);
};

export const CerebroHierarchyTreeItem: React.FC<CerebroHierarchyFolderTreeProps> = ({ folder, selectedGuid }) => {
	if (folder.folders.length > 0) {
		return (
			<TreeItem key={folder.guid} nodeId={folder.guid} label={folder.name}>
				{folder.folders.map(item => (
					<CerebroHierarchyTreeItem key={item.guid} folder={item} selectedGuid={selectedGuid} />
				))}
			</TreeItem>
		);
	}

	return <TreeItem key={folder.guid} nodeId={folder.guid} label={folder.name} />;
};

function getNodeIds(folder: DataRoomFolder): string[] {
	let nodes = [] as string[];
	nodes.push(folder.guid);

	if (folder.folders.length > 0) {
		folder.folders.map(item => {
			nodes.push(...getNodeIds(item));
		});
	}

	return nodes;
}
